import { formMachine } from '../../../xform';
import accountNumberConfig from './accountNumberConfig';
import nicknameConfig from './nicknameConfig';
import routingNumberConfig from './routingNumberConfig';
const createBankFormMachine = (apiMachineRef) => formMachine.withContext({
    fieldConfigs: [
        routingNumberConfig(apiMachineRef),
        accountNumberConfig(),
        nicknameConfig()
    ]
});
export default createBankFormMachine;
